import * as yup from "yup"
import { Grid2 as Grid, Button } from "@mui/material"
import { Formik } from "formik"
import { WithAllegati } from "../../types"
import { useMemo } from "react"
import { transformErrorForForm } from "../../utils/utils"
import { FormInDialogEditProps } from "../DialogForm"
import { useTranslation } from "react-i18next"
import { AllegatiField } from "./allegatiHelpers"


export default function AllegatiForm({ item, save, ref }: FormInDialogEditProps<WithAllegati>) {
  const { t } = useTranslation()

  const schema = useMemo(
    () =>
      yup.object().shape({
        allegati_data: yup.array().of(
          yup.object().shape({
            attachment: yup.mixed().required(t("allegati.file")),
          })
        ),
        
      }),
    [t]
  )

  return (
    <Formik
      validationSchema={schema}
      initialValues={item}
      enableReinitialize
      onSubmit={(values, formikBag) => {
        return save(values as WithAllegati).catch((e) => {
          const localError = transformErrorForForm(e)
          formikBag.setErrors(localError)
        })
      }}
    >
      {({ handleSubmit, values }) => {
        return (
          <form onSubmit={handleSubmit} noValidate>
            <Grid container spacing={3}>
              <Grid size={12}>
              <AllegatiField name="allegati_data" values={{ ...values, allegati_data: values.allegati_data ?? [] }} />
              </Grid>
            </Grid>

            <Button ref={ref} type="submit" color="primary" sx={{ display: "none" }}></Button>
          </form>
        )
      }}
    </Formik>
  )
}
